import React from 'react';
import { Edit, email, FormTab, required, TabbedForm, TextField, TextInput } from 'react-admin';
import { OwnerEditToolbar } from '../toolbars';

export default ({ permissions, ...props }) => (
    <Edit undoable={false} title='Owner' {...props}>
        <TabbedForm redirect="show" toolbar={<OwnerEditToolbar />}>
            <FormTab label="Summary">
                <TextField source="name" />
                {permissions && permissions.indexOf('PatchOwner') >= 0 && (permissions.indexOf('owner') >= 0 || permissions.indexOf('owner.email') >= 0) ?
                    <TextInput fullWidth={true} source="email" type="email" validate={[required(), email()]} /> :
                    <TextField source="email" />
                }
                {permissions && permissions.indexOf('PatchOwner') >= 0 && (permissions.indexOf('owner') >= 0 || permissions.indexOf('owner.password') >= 0) ?
                    <TextInput fullWidth={true} source="password" type="password" /> :
                    null
                }
                {permissions && permissions.indexOf('PatchOwner') >= 0 && (permissions.indexOf('owner') >= 0 || permissions.indexOf('owner.destination') >= 0) ?
                    <TextInput fullWidth={true} source="destination" type="url" validate={required()} /> :
                    <TextField source="destination" />
                }
            </FormTab>
            <FormTab label="SIPP">
                {permissions && permissions.indexOf('PatchOwner') >= 0 && (permissions.indexOf('owner') >= 0 || permissions.indexOf('owner.sipp') >= 0 || permissions.indexOf('owner.sipp.destination') >= 0) ?
                    <TextInput fullWidth={true} label="Destination" source="sipp.destination" type="url" /> :
                    <TextField label="Destination" source="sipp.destination" />
                }
            </FormTab>
            <FormTab label="Verification">
                {permissions && permissions.indexOf('PatchOwner') >= 0 && (permissions.indexOf('owner') >= 0 || permissions.indexOf('owner.verification') >= 0 || permissions.indexOf('owner.verification.id') >= 0) ?
                    <TextInput fullWidth={true} label="ID" source="verification.id" validate={required()} /> :
                    <TextField label="ID" source="verification.id" />
                }
                {permissions && permissions.indexOf('PatchOwner') >= 0 && (permissions.indexOf('owner') >= 0 || permissions.indexOf('owner.verification') >= 0 || permissions.indexOf('owner.verification.secret') >= 0) ?
                    <TextInput fullWidth={true} label="Secret" source="verification.secret" type="password" /> :
                    null
                }
            </FormTab>
        </TabbedForm>
    </Edit>
);
